import { ObjectFieldTemplateProps } from "@rjsf/utils";

function CategoriesTemplate(props: ObjectFieldTemplateProps, func: any) {


  return (
    <>
      <div className="cms-section">
        <div className="h3">
          {props.title}
        </div>
        <div className="section row">
          <div className="col-12">
            <div className="property-wrapper">
              {func("category_id", props)?.content}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CategoriesTemplate;
